import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import getSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import isSenderImageEnabled from 'mini-options-store/lib/utils/isSenderImageEnabled';
import mailStore from 'owa-mail-store/lib/store/Store';
import multiSelect from 'mini-mail-list-store/lib/actions/multiSelect/multiSelect';
import React from 'react';
import SearchTableQuery from 'mini-mail-list-store/lib/store/schema/SearchTableQuery';
import { computed } from 'mobx';
import { MailListItem, MailListItemProps } from 'mini-mail-list-item/lib/components/MailListItem';
import { observer } from 'mobx-react';
import { TableQueryType } from 'mini-mail-list-store/lib/store/schema/TableQuery';
import {
    MailListItemViewProps,
    mailListItemTouchBehavior,
} from './TouchBehavior/MailListItemTouchBehavior';
@observer
class MailListItemWrapper extends React.Component<MailListItemViewProps, any> {
    private mailListItemRef = React.createRef<HTMLElement>();

    private onMultiSelect(rowId: string): void {
        multiSelect(rowId, 'Persona' /* source */);
    }

    @computed
    private get getMailListItemProps(): MailListItemProps {
        const { mailListItemDataProps: data, richContents } = this.props;
        const { tableQuery, isInCheckedMode, termsToHighlight } = getSelectedTableView() ?? {};
        const mailItemFolder = mailStore.folders.folderTable.get(data.parentFolderId);
        const isSearchMode = tableQuery?.type === TableQueryType.Search;
        const shouldShowFolderLabel =
            isSearchMode &&
            (tableQuery as SearchTableQuery).searchFolderScopeId ===
                folderNameToId('msgfolderroot');

        const mailListItemProps: MailListItemProps = {
            ...data,
            isInCheckedMode: isInCheckedMode,
            shouldShowAvatar: isSenderImageEnabled(),
            parentFolderName: mailItemFolder?.DisplayName,
            onMultiSelect: this.onMultiSelect,
            termsToHighlight: termsToHighlight,
            richContents,
            shouldShowFolderLabel,
            isSearchResult: isSearchMode,
        };
        return mailListItemProps;
    }

    render() {
        return <MailListItem {...this.getMailListItemProps} ref={this.mailListItemRef} />;
    }
}

export const MailListItemWithTouchBehavior = mailListItemTouchBehavior(MailListItemWrapper);
